import { getData, postData } from "@/lib/request";

export const getListNotice = (params) =>
  getData("/web/project/getListNotice", params);
export const getDetailNotice = (params) =>
  getData("/web/project/getDetailNotice", params);
export const checkRead = (params) => postData("/web/project/checkRead", params);
